import * as React from "react";
import {Display} from "../Display";

import "./vebox-overlay.scss";

export interface VeboxOverlayTargetProps {
    show: boolean;
    overlay?: any;
    overlayClassName?: string;
}

export interface VeboxOverlayController {
    show: (child?: any) => void;
    clear: () => void;
    targetProps: VeboxOverlayTargetProps;
}

export class VeboxOverlay {

    public static useTarget = (defaultOverlay?: any): VeboxOverlayController => {

        const [overlay, setOverlay] = React.useState();

        const show = (child = defaultOverlay) => {
            setOverlay(child);
        };

        const clear = () => {
            setOverlay(null);
        };

        const veboxOverlayTargetProps: VeboxOverlayTargetProps = {
            show: Boolean(overlay),
            overlay
        };

        return {
            show,
            clear,
            targetProps: veboxOverlayTargetProps,
        };
    }

    public static Target: React.FC<VeboxOverlayTargetProps & React.HTMLAttributes<any>> = (props) => {
        return (
            <div {...props} className={"vebox-overlay-target-wrapper " + props.className}>
                {props.children}
                <Display isVisible={props.overlay}>
                    <div className={"vebox-overlay " + props?.overlayClassName}>
                        {props.overlay}
                    </div>
                </Display>
            </div>
        );
    }
}
